export default {
    data() {
        return {
            top: 0
        }
    },

    props: {
        width: {
            type: Number,
            default: 154
        },
        backgroundColor: {
            type: String,
            default: '#C5C5C5'
        },
        height: {
            type: Number,
            default: 30
        }
    },

    watch: {

    },

    created() {
        this.top = this.$props.height / 2;
    },

    methods: {

    }
}
